<script setup lang="ts">
import ColumnsMainComponent from './columns/ColumnsMainComponent.vue';
import ColumnsMainMobileComponent from './columns/ColumnsMainMobileComponent.vue';
</script>

<template>
  <div class="main">
    <ColumnsMainMobileComponent class="mobile" />
    <ColumnsMainComponent class="desktop" />
  </div>
</template>

<style scoped lang="scss">
.main {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1170px;
}

.mobile {
  display: block;
}

.desktop {
  display: none;
}

@media screen and (min-width: 768px) {
  .mobile {
    display: none;
  }

  .desktop {
    display: block;
  }
}
</style>
